import React from "react";
import { Link } from "@inertiajs/react";

interface Step {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
}

interface Props {
  steps: readonly Step[];
}

export function ProductHowItWorks({ steps }: Props): React.ReactElement {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-4">
          How the <span className="text-primary">analysis works</span>
        </h2>
        <p className="text-center text-surface-foreground/80 mb-12 max-w-2xl mx-auto">
          A conservative, multi gate approach. If any check fails, it doesn't
          get recommended.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="group p-6 rounded-3xl border bg-background/50 hover:border-primary/20 hover:bg-primary/5 transition-colors"
            >
              <div className="size-12 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4">
                <Icon className="size-6" />
              </div>
              <h3 className="text-xl font-bold mb-3">{title}</h3>
              <p className="text-surface-foreground/80 text-sm leading-relaxed">
                {description}
              </p>
            </div>
          ))}
        </div>
        <p className="text-center mt-10 text-sm">
          <Link href="/how-it-works" className="text-primary hover:underline">
            Learn more about our methodology
          </Link>
        </p>
      </div>
    </section>
  );
}
